function scrollToItem(item_id) {
    //console.log("item_id: ", item_id);
    if (window.innerWidth < 749) {
        var sectionOffset = document.getElementById(item_id).offsetTop - 160;
    } else {
        var sectionOffset = document.getElementById(item_id).offsetTop - 200;
    }
    window.scrollTo({
        top: sectionOffset,
        behavior: "smooth",
    });
}
if (!customElements.get('out-line')) {
    class Outline extends HTMLElement {
      constructor() {
        super();
        this.outline_item_btn = this.querySelectorAll('li');
        this.controlId = this.getAttribute('aria-controls');
        this.controlType = this.getAttribute('aria-type');
        
        if (this.controlId && document.querySelector("#" + this.controlId)) {     
                   
            this.controlPanel = document.querySelector("#" + this.controlId)
            this.outline_item = this.controlPanel.querySelectorAll(".outline")
            for (let index = 0; index < this.outline_item_btn.length; index++) {
              this.outline_item_btn[index].addEventListener('click', this.handleClick.bind(this));
            }
        }
      }
    
      handleClick(evt) {
        if (this.controlType == "text") {
          for (let index = 0; index < this.outline_item_btn.length; index++) {
            this.outline_item_btn[index].classList.remove('underline')
            this.outline_item_btn[index].classList.add('text-theme-light')
          }
          evt.target.classList.add('underline');
          evt.target.classList.remove('text-theme-light');
          let index = Array.prototype.indexOf.call(this.children, evt.target);
          this.outline_item[index].classList.add('outline-highlight');
          setTimeout(() => {
            this.outline_item[index].classList.remove('outline-highlight');
          }, 3000);
          this.scrollToOffset(this.outline_item[index].offsetTop)
        }
        
      }
    
      scrollToOffset(pos_offset) {
        let sectionOffset = 0
        if (window.innerWidth < 749) {
            sectionOffset = pos_offset - 160;
        } else {
            sectionOffset = pos_offset - 200;
        }
        window.scrollTo({
            top: sectionOffset,
            behavior: "smooth",
        });
      }
    }
    
    customElements.define('out-line', Outline);
}